/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchPropertyResultDto } from '../../models/search-property-result-dto';

export interface SearchForPropertyByPfi$Params {
  pfi: string;
}

export function searchForPropertyByPfi(
  http: HttpClient,
  rootUrl: string,
  params: SearchForPropertyByPfi$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchPropertyResultDto>> {
  const rb = new RequestBuilder(rootUrl, searchForPropertyByPfi.PATH, 'get');
  if (params) {
    rb.path('pfi', params.pfi, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchPropertyResultDto>;
      }),
    );
}

searchForPropertyByPfi.PATH = '/search/property/pfi/{pfi}';
